import axios from 'axios';

import { RawAssetTypeCode } from 'types/models/asset-type';
import SamplePoint, { SamplePointId } from 'types/models/samplePoint';
import { APIResponseParsed } from 'types/response';
import { getRequest } from 'utils/HttpRequest/http-request-utils';

import { parseAxiosError } from './utils/parse-axios-error';

/**
 * Partial sample point returned by the getMany endpoint.
 * Only includes fields explicitly selected by the backend controller.
 */
export type PartialSamplePoint = Pick<
  SamplePoint,
  'config' | 'name' | 'sid' | 'assetTypeId' | 'sensorTags' | 'site'
> & {
  id: SamplePointId;
};

// ==============================
// REQUESTS
// ==============================
async function fetchSamplePointsByDeviceId(
  deviceId: number
): Promise<APIResponseParsed<PartialSamplePoint[]>> {
  try {
    const response = await getRequest<PartialSamplePoint[]>(
      '/samplepoint?join=device&join=site',
      {
        params: {
          s: {
            $and: [
              {
                deviceId: { $eq: deviceId }
              },
              {
                statusActive: { $eq: 1 }
              },
              {
                assetTypeId: {
                  $notin: [
                    RawAssetTypeCode.UNKNOWN,
                    RawAssetTypeCode.HEATER_SENSOR,
                    RawAssetTypeCode.INTERNAL_SENSOR,
                    RawAssetTypeCode.SECURITY_CAMERA
                  ]
                }
              }
            ]
          }
        }
      }
    );
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

export default {
  fetchSamplePointsByDeviceId
};
